/* eslint-disable check-file/filename-blocklist */
import React from 'react';
import { FormattedMessage } from 'react-intl-next';

import { InvisibleTableHeaderText } from './RestrictionsDialog/panels/styled';

export const CurrentUserLabel = (
	<FormattedMessage
		id="restrictions.dialog.word.you"
		defaultMessage="You"
		description="current user label"
	/>
);

export const RESTRICTION_DIALOG_TABLE_HEAD = {
	cells: [
		{
			width: 65,
			content: (
				<FormattedMessage
					id="restrictions.dialog.table.header.users"
					defaultMessage="User/group"
					description="header text of restrictions dialog column, whose rows contain a user or a group"
				>
					{(tableHeaderText) => (
						<InvisibleTableHeaderText>{tableHeaderText}</InvisibleTableHeaderText>
					)}
				</FormattedMessage>
			),
		},
		{
			width: 23,
			content: (
				<FormattedMessage
					id="restrictions.dialog.table.header.permission"
					defaultMessage="Permission"
					description="header text of restrictions dialog column which contain permission select"
				>
					{(tableHeaderText) => (
						<InvisibleTableHeaderText>{tableHeaderText}</InvisibleTableHeaderText>
					)}
				</FormattedMessage>
			),
		},
		{
			width: 12,
			content: (
				<FormattedMessage
					id="restrictions.dialog.table.header.actions"
					defaultMessage="Actions"
					description="header text of restrictions dialog column which contain actions button"
				>
					{(tableHeaderText) => (
						<InvisibleTableHeaderText>{tableHeaderText}</InvisibleTableHeaderText>
					)}
				</FormattedMessage>
			),
		},
	],
};

// In order to allow us to fetch any data for draft content always we need to specify the status
export const ALLOWED_CONTENT_STATUSES = ['current', 'draft', 'archived'];

export const ANALYTICS_SOURCE = 'restrictionsDialog';
